module.exports = __webpack_public_path__ + "static/media/icon_trailing.9a1edbb2.svg";